import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap';
import { ProjectsService } from 'app/_services/projects.service';
import { DiscussionMarketShareService } from './discussion-market-share.service';
import { DiscussionTotalReportService } from '../discussion-total-report/discussion-total-report.service';


const moment = require('moment');
@Component({
  selector: 'discussion-market-share',
  templateUrl: './discussion-market-share.component.html',
  styleUrls: ['./discussion-market-share.component.scss']
})
export class DiscussionMarketShareComponent implements OnInit {


  brandDropDownSettings: any;
  brandSelected = [];
  brandSelectedFilter = [];
  brands = [];

  reportName = "";
  dataReport: Object;

  projectDropDownSettings: any;
  projectSelected = [];
  projectSelectedFilter = [];
  projects = [];

  typeReport = 'day';
  typeReportFilter = 'day';
  notSpam = true;
  notSpam2 = false;
  typeAction = 'create';

  dtOptions: DataTables.Settings = {};
  dataList = [];
  dataTableShow = false;
  currentConfigItem: object;
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  daterange: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  daterangeFilter: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  dateRangeRecommand: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };


  options = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };

  optionsFilter = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterangeFilter.start,
    endDate: this.daterangeFilter.end
  };

  optionsRecommand = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.dateRangeRecommand.start,
    endDate: this.dateRangeRecommand.end
  };


  listPosts = [];
  sourceRecommand = 'facebook';
  typeSentimentPost = 'neg';

  arrayPost = [];
  ckeditorContent = '';
  showSuggestPost = false;

  pageSizeRecommand = 15;
  currentPageRecommand = 1;
  totalRecommandPost = 15;

  currentSourceEdit = 'facebook';

  constructor(
    private projectsService: ProjectsService,
    private toastrService: ToastrService,
    private discussionMarketShareService: DiscussionMarketShareService,
    private modalService: BsModalService,
    private discussionTotalReportService: DiscussionTotalReportService
  ) {
    this.getDataFromServer();
    this.getProject();
    this.getReportManager();
  }

  ngOnInit(): void {
    this.brandDropDownSettings = {
      singleSelection: false,
      text: 'Chọn thương hiệu',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.projectDropDownSettings = {
      singleSelection: false,
      text: 'Chọn chủ đề',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [0, 1, 2, 3, 4, 5], 'searchable': true }
      ]
    };
  };

  selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterange.start = value.start;
    this.daterange.end = value.end;

    this.options.startDate = this.daterange.start;
    this.options.endDate = this.daterange.end;
  }

  selectedDateFilter(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterangeFilter.start = value.start;
    this.daterangeFilter.end = value.end;
  }

  showPreviewReport(item, modalRef) {
    this.typeAction = 'view';
    this.dataReport = {};
    this.dataReport = JSON.parse(JSON.stringify(item));
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  showCreateReport(modalRef) {
    this.typeAction = 'create';
    this.dataReport = {};
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          let projectItem = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(projectItem);
        });
      }
    });

  }

  getDataFromServer() {
    this.dataTableShow = false;
    this.discussionMarketShareService.getAll().subscribe(res => {
      if (res.success) {
        res.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.brands.push(obj);
        });
      } else {
        this.toastrService.error('Lỗi hệ thống, Vui lòng liên hệ admin', ' Thông báo')
      }
    });
  }

  getReportManager() {
    let filter = {
      gte: this.daterangeFilter.start.valueOf(),
      lte: this.daterangeFilter.end.valueOf(),
      projects: this.projectSelectedFilter,
      brands: this.brandSelectedFilter,
      typeReport: this.typeReportFilter,
      report_code: ["BCTPTL"]
    };
    this.dataTableShow = false;
    this.discussionMarketShareService.getAllReportManager(filter).subscribe(response => {
      this.dataTableShow = true;
      this.dataList = response.data;
    });
  }


  clickReport() {
    let dateStartEnd = {
      start: moment(this.daterange.start.valueOf()),
      end: moment(this.daterange.end.valueOf())
    }

    let lastDate = dateStartEnd.start.valueOf() - 1 * 24 * 60 * 60 * 1000;
    if (this.typeReport == "week") {
      lastDate = dateStartEnd.start.valueOf() - 7 * 24 * 60 * 60 * 1000;
    } else if (this.typeReport == "month") {
      lastDate = dateStartEnd.start.subtract(1, 'months').valueOf();
    } else if (this.typeReport == "year") {
      lastDate = dateStartEnd.start.subtract(1, 'years').valueOf();
    } else if (this.typeReport == "option") {
      let dayRange = Math.ceil((dateStartEnd.end.valueOf() - dateStartEnd.start.valueOf()) / (1 * 24 * 60 * 60 * 1000));
      lastDate = dateStartEnd.start.valueOf() - dayRange * 24 * 60 * 60 * 1000;
    }
    if (this.brandSelected.length == 0 || this.brandSelected.length > 5) {
      this.toastrService.warning("Bạn phải chọn thương hiệu, tối đa 5 thương hiệu", "Thông báo!");
      return;
    }
    this.dataReport = {};
    this.arrayPost = [];

    let filter = {
      gte: lastDate,
      from: this.daterange.start.valueOf(),
      lte: this.daterange.end.valueOf(),
      projects: this.projectSelected,
      brands: this.brandSelected,
      type: this.typeReport,
      notSpam: this.notSpam2
    };
    this.discussionMarketShareService.getReport({ filter: filter, index: 'full' }).subscribe(response => {
      let data = response.data;
      if (data) {
        let dataFilter = data.aggregations.dataFilter;
        let dataLastFilter = data.aggregations.dataLastFilter;
        let dataReportFilter = {
          total: dataFilter.doc_count,
          name: this.generalName(this.typeReport, filter.from, filter.lte),
          data: {}
        };
        for (const property in dataFilter) {
          if (property != "doc_count" && property != "meta") {
            dataReportFilter.data[property] = dataFilter[property].doc_count;
          }
        }
        let dataLastReportFilter = {
          total: dataLastFilter.doc_count,
          name: this.generalName(this.typeReport, lastDate, filter.from),
          data: {}
        };
        for (const property in dataLastFilter) {
          if (property != "doc_count" && property != "meta") {
            dataLastReportFilter.data[property] = dataLastFilter[property].doc_count;
          }
        }
        this.dataReport = {
          report_desc: "Báo cáo thị phần thảo luận các thương hiệu",
          report_type: this.typeReport,
          report_name: "Báo cáo thị phần thảo luận các thương hiệu " + this.generalName(this.typeReport, filter.from, filter.lte),
          report_project: this.projectSelected,
          report_brand: this.brandSelected,
          report_start_date: new Date(this.daterange.start.valueOf()),
          report_end_date: new Date(this.daterange.end.valueOf()),
          report_code: "BCTPTL", // báo cáo thị phần thảo luận
          data: {
            dataReportFilter: dataReportFilter,
            dataLastReportFilter: dataLastReportFilter,
            colorGeneral: data.colorGeneral,
            htmlTop: ""
          }
        }
        const filter2 = {
          gte: lastDate,
          from: this.daterange.start.valueOf(),
          lte: this.daterange.end.valueOf(),
          projects: this.projectSelected,
          brands: this.brandSelected,
          type: this.typeReport,
          notSpam : this.notSpam
        };
        this.discussionTotalReportService.getReport({ filter: filter , index:  'full' }).subscribe(response => {
          let data = response.data;
          if (data) {
            let dataFilter = data.aggregations.dataFilter;
            let dataLastFilter = data.aggregations.dataLastFilter;
            let dataReportFilter = {
              total: 0,
              name: this.generalName(this.typeReport, filter.from, filter.lte),
              data: {}
            };
    
            for (const property in dataFilter) {
              if (property != "doc_count" && property != "meta") {
                dataReportFilter.data[property] = dataFilter[property].doc_count;
                dataReportFilter.total += dataFilter[property].doc_count;
              }
            }
            let dataLastReportFilter = {
              total: 0,
              name: this.generalName(this.typeReport, lastDate, filter.from),
              data: {}
            };
            for (const property in dataLastFilter) {
              if (property != "doc_count" && property != "meta") {
                dataLastReportFilter.data[property] = dataLastFilter[property].doc_count;
                dataLastReportFilter.total += dataLastFilter[property].doc_count;
              }
            }
            let temp = JSON.parse(JSON.stringify(this.dataReport));
            this.dataReport = null;
            this.dataReport = temp;
            this.dataReport['data']['dataReportFilter1'] = dataReportFilter;
            this.dataReport['data']['dataLastReportFilter1'] = dataLastReportFilter;
         
            
    
          }
        });



      }
    });

   
    // console.log(filter);
  }
  generalName(typeReport, start, end) {
    let name = ""
    if (typeReport == "day" && (end - start) <= 24 * 60 * 60 * 1000) {
      name = "Ngày " + moment(start).format('DD/MM/Y');
    } else if (typeReport == "month" && (end - start) <= 31 * 24 * 60 * 60 * 1000 && moment(start).format('MM/Y') == moment(end - 1).format('MM/Y')) {
      name = "Tháng " + moment(start).format('MM/Y');
    } else {
      name = moment(start).format('DD/MM/Y') + " - " + moment(end - 1).format('DD/MM/Y');;
    }
    return name;
  }
  clickSave() {
    if (this.dataReport) {
      if (this.reportName == "") {
        this.toastrService.warning("Bạn phải nhập tiêu đề cho báo cáo!", "Thông báo!");
        return;
      }
      this.dataReport["report_title"] = this.reportName.trim();
      this.discussionMarketShareService.createReportManager(this.dataReport).subscribe(response => {
        if (response.success) {
          this.toastrService.success("Đã tạo báo cáo thành công!", "Thông báo!");
          this.getReportManager();
        } else {
          this.toastrService.warning(response.msg, "Thông báo!");
        }
        this.closeModal();
      });
    } else {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
    }
  }
  clickDeleteItem(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef);
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
  }
  clickSaveConfirm(modalRef) {
    if (!this.dataReport) {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
      return;
    }
    this.reportName = "";
    this.modalRef = this.modalService.show(modalRef);
  }

  deleteReport() {
    this.discussionMarketShareService.deleteReport(this.currentConfigItem['_id']).subscribe(res => {
      if (res.success) {
        this.getReportManager();
        this.toastrService.success('Xóa báo cáo thành công !', 'Thông báo');
        this.closeModal();
      } else {
        this.toastrService.error('Xóa báo cáo thất bại !', 'Thông báo');
      }
    });
  }
  closeModal() {
    this.modalRef.hide();
    this.modalRef2.hide();
  }

  showRecommentPost(modalRef) {
    this.viewPost()
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal-1'
    });
  }

  pageChange(number) {
    this.listPosts = [];
    this.currentPageRecommand = number;
    this.viewPost();
  }

  selectedDateRecommand(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.dateRangeRecommand.start = value.start;
    this.dateRangeRecommand.end = value.end;


    this.optionsRecommand.startDate = this.dateRangeRecommand.start;
    this.optionsRecommand.endDate = this.dateRangeRecommand.end;
  }

  viewPost() {
    this.showSuggestPost = false;
    if (this.projectSelected.length == 0 && this.brandSelected.length == 0) {
      this.toastrService.warning("Bạn phải chọn thương hiệu hoặc chủ đề", "Thông báo!");
      return;
    }
    // this.currentPageRecommand = 1;
    this.totalRecommandPost = 0;

    if (this.sourceRecommand == 'facebook') {
      const filterFacebook = {
        filter: {
          gte: this.dateRangeRecommand.start.valueOf(),
          lte: this.dateRangeRecommand.end.valueOf()
        },
        brands: this.brandSelected,
        size: this.pageSizeRecommand,
        from: (this.currentPageRecommand - 1) * this.pageSizeRecommand,
        typeSentimentPost: this.typeSentimentPost,
        type: 'facebook',
        notSpam: this.notSpam
      };
      this.discussionMarketShareService.getSuggestionPost(filterFacebook).subscribe(res => {
        if (res.success) {
          this.listPosts = res.data.hits.hits;
          this.totalRecommandPost = res.data.hits.total.value < (10000 - this.pageSizeRecommand) ? res.data.hits.total.value : (10000 - this.pageSizeRecommand)
          this.showSuggestPost = true;
        }
      });
    }
    if (this.sourceRecommand == 'news') {
      let filter = {
        gte: this.dateRangeRecommand.start.valueOf(),
        lte: this.dateRangeRecommand.end.valueOf(),
        size: this.pageSizeRecommand,
        from: (this.currentPageRecommand - 1) * this.pageSizeRecommand,
        sentiment: [this.typeSentimentPost],
        brands: this.brandSelected
      };
      this.discussionMarketShareService.getArticleTopic({ filter: filter, size: 1000 }).subscribe(res => {
        if (res.success) {
          this.listPosts = res.data.hits.hits;
          this.totalRecommandPost = res.data.hits.total.value < (10000 - this.pageSizeRecommand) ? res.data.hits.total.value : (10000 - this.pageSizeRecommand);
          this.showSuggestPost = true;
        }
      });
    }

  }

  clickSaveRecommand(item) {

    this.arrayPost.push(item);
  }
  clickRemoveRecommand(item) {
    for (var i = 0; i < this.arrayPost.length; i++) {
      if (this.arrayPost[i]["_source"]["docId"] == item["_source"]["docId"]) {
        this.arrayPost.splice(i, 1);
        break;
      }
    }
  }

  checkExitsRecommand(item) {
    let check = false;
    for (var i = 0; i < this.arrayPost.length; i++) {
      if (this.arrayPost[i]["_source"]["docId"] == item["_source"]["docId"]) {
        check = true;
        break;
      }
    }
    return check;
  }

  async savePosts() {
    let htmlTop = '';
    this.arrayPost.forEach(data => {
      htmlTop += `${data._source.message || data._source.content}<br>`;
    })
    let tempDataReport = JSON.parse(JSON.stringify(this.dataReport));
    tempDataReport['data']['htmlTop'] = htmlTop;
    this.dataReport = {};
    this.dataReport = tempDataReport;

    this.modalRef.hide();
  }

  clickEditReportItem(item, modalRef) {
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
    this.ckeditorContent = this.currentConfigItem['data'].htmlTop
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-lg'
    });
  }
  onCurrentSourceEditChange() {
    this.ckeditorContent = this.currentConfigItem['data'].htmlTop;

  }

  saveEditPost() {
    this.currentConfigItem['data'].htmlTop = this.ckeditorContent;


    this.discussionMarketShareService.updateReport(this.currentConfigItem['_id'], this.currentConfigItem['data']).subscribe(res => {
      if (res.success) {
        this.toastrService.success('Update thành công', 'Thông báo');
        this.modalRef.hide();
        this.getReportManager();
        this.dataReport = null;
        this.dataReport = this.currentConfigItem;
      }
    });
  }


  onItemSelect(item: any) {
  }
  OnItemDeSelect(item: any) {
  }

  onSelectAll(items: any) {
  }

  onDeSelectAll(items: any) {
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/discussion-market-share/discussion-market-share.component.ts